import { graphql, useStaticQuery } from "gatsby";
import { GetStartedOurProcessQuery } from "./query.generated";

export type CMSOurProcessData = GetStartedOurProcessQuery["cms"]["site"];

export function useStaticOurProcessQuery(): CMSOurProcessData {
  const data = useStaticQuery<GetStartedOurProcessQuery>(
    graphql`
      query GetStartedOurProcess {
        cms {
          site(hostname: "www.italymondo.com") {
            contactPage: pages(
              contentType: "italymondo_contact.IMContactPage"
            ) {
              ... on CMS_IMContactPage {
                process {
                  cta {
                    page {
                      url
                    }
                    title
                  }
                  description
                  steps {
                    description
                    name
                    step
                  }
                  title
                }
                processMedia {
                  ... on CMS_MediaImagesBlock {
                    __typename
                    images {
                      image {
                        alt
                        url
                        urlSharp {
                          childImageSharp {
                            gatsbyImageData(
                              placeholder: BLURRED
                              width: 650
                              height: 550
                            )
                          }
                        }
                      }
                    }
                  }
                  ... on CMS_TestimonialsBlock {
                    __typename
                    testimonials {
                      testimonial {
                        date
                        longMessage
                        name
                        photo {
                          alt
                          url
                          urlSharp {
                            childImageSharp {
                              gatsbyImageData(
                                height: 60
                                width: 60
                                placeholder: BLURRED
                              )
                            }
                          }
                        }
                        sourceDetail {
                          logo {
                            title
                            url
                          }
                          url
                        }
                      }
                    }
                  }
                }
                processMediaPlacement
                processSectionName
              }
            }
          }
        }
      }
    `
  );
  return data.cms.site;
}
